import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Orb from './components/Orb';
import RotatingText from './components/RotatingText';
import VideoSection from './components/VideoSection';
import SelfCheckout from './components/SelfCheckout';
import CustomGpt from './components/CustomGpt';
import OurPartners from './components/OurPartners';
import Footer from './components/Footer';
import OrbFooter from './components/OrbFooter';






function App() {
  return (
    <div className="App" style={{ position: 'relative', height: '100vh' }}>
      <Navbar />
      {/* Render multiple orbs in the top section */}
      <div className="orb-container">
        {[...Array(4)].map((_, index) => (
          <Orb key={index} index={index} />
        ))}
      </div>
      <RotatingText />
      <VideoSection />
      <SelfCheckout />
      <CustomGpt />
      <OurPartners />
      <div className="orb-footer-container">
        {[...Array(4)].map((_, index) => (
          <OrbFooter key={index} index={index} />
        ))}
      </div>
      <Footer />
      {/* Render multiple orbs inside the footer */}
      
    </div>
  );
}

export default App;


// ['Systems', 'Processes', 'Workflows', 'Operations'];
